// app/javascript/controllers/url_selector_controller.js
import {Controller} from "@hotwired/stimulus"

/**
 * A reusable controller for handling select elements that navigate to URLs on change
 *
 * Example usage:
 * <select data-controller="url-selector" data-action="change->url-selector#navigate">
 *   <option value="/path/to/page1">Option 1</option>
 *   <option value="/path/to/page2">Option 2</option>
 * </select>
 */
export default class extends Controller {
    static values = {
        turbo: {type: Boolean, default: true}
    }

    connect() {
        //console.log("URL selector controller connected");
    }

    /**
     * Navigates to the URL selected in the dropdown
     *
     * @param {Event} event - The change event from the select element
     */
    navigate(event) {
        let selectedUrl = event.target.value;

        if (!selectedUrl) return;

        // Preserve stone_type parameter if it exists
        const stoneTypeSelect = document.getElementById('stone_type_select');
        
        if (stoneTypeSelect) {
            // Get parameterized format from selected option's data-param attribute
            const selectedOption = stoneTypeSelect.selectedOptions[0];
            const stoneTypeParam = selectedOption?.dataset.param || stoneTypeSelect.value;
            
            if (stoneTypeParam) {
                const separator = selectedUrl.includes('?') ? '&' : '?';
                selectedUrl = `${selectedUrl}${separator}stone_type=${stoneTypeParam}`;
            }
        }

        if (this.hasTurboValue && this.turboValue && typeof Turbo !== "undefined") {
            // Use Turbo navigation for a smoother experience
            Turbo.visit(selectedUrl);
        } else {
            // Fall back to traditional navigation
            window.location = selectedUrl;
        }
    }
}